var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      class: [
        "k-card",
        _vm.$slots.select ? "k-with-selection-controls" : undefined,
      ],
      style: [_vm.gridItemStyle, _vm.focusStyle],
      on: {
        focus: _vm.onFocus,
        mouseenter: _vm.onHover,
        mousedown: _vm.onMouseDown,
        click: _vm.onClick,
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          return _vm.onEnter.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          class: ["k-card-area", ..._vm.cardAreaClasses],
          style: { backgroundColor: _vm.$themeTokens.surface },
        },
        [
          _c("div", { staticClass: "k-upper-card-area" }, [
            _c(
              "div",
              { staticClass: "k-around-title" },
              [
                _c(
                  "span",
                  {
                    staticClass: "visuallyhidden",
                    attrs: { id: `k-card-title-${_vm._uid}` },
                  },
                  [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")]
                ),
                _c(
                  _vm.headingElement,
                  {
                    tag: "component",
                    staticClass: "k-heading",
                    style: { color: _vm.$themeTokens.text },
                  },
                  [
                    _vm.to
                      ? _c(
                          "router-link",
                          {
                            staticClass: "k-title",
                            attrs: {
                              event: "",
                              to: _vm.to,
                              draggable: "false",
                              "aria-labelledby": `k-card-title-${_vm._uid}`,
                            },
                            nativeOn: {
                              focus: function ($event) {
                                return _vm.onTitleFocus.apply(null, arguments)
                              },
                              blur: function ($event) {
                                return _vm.onTitleBlur.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { "aria-hidden": "true" } },
                              [
                                _vm.$scopedSlots.title
                                  ? _vm._t("title", null, {
                                      titleText: _vm.title,
                                    })
                                  : _c("KTextTruncator", {
                                      attrs: {
                                        text: _vm.title,
                                        maxLines: _vm.titleMaxLines,
                                      },
                                    }),
                              ],
                              2
                            ),
                          ]
                        )
                      : _c(
                          "span",
                          {
                            staticClass: "k-title",
                            attrs: {
                              tabindex: "0",
                              "data-focus": "true",
                              "aria-labelledby": `k-card-title-${_vm._uid}`,
                            },
                            on: {
                              focus: _vm.onTitleFocus,
                              blur: _vm.onTitleBlur,
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { "aria-hidden": "true" } },
                              [
                                _vm.$scopedSlots.title
                                  ? _vm._t("title", null, {
                                      titleText: _vm.title,
                                    })
                                  : _c("KTextTruncator", {
                                      attrs: {
                                        text: _vm.title,
                                        maxLines: _vm.titleMaxLines,
                                      },
                                    }),
                              ],
                              2
                            ),
                          ]
                        ),
                  ],
                  1
                ),
                _vm.hasAboveTitleArea
                  ? _c(
                      "div",
                      {
                        staticClass: "k-above-title",
                        attrs: { "data-test": "aboveTitle" },
                      },
                      [_vm._t("aboveTitle")],
                      2
                    )
                  : _vm._e(),
                _vm.hasBelowTitleArea
                  ? _c(
                      "div",
                      {
                        staticClass: "k-below-title",
                        style: { color: _vm.$themeTokens.annotation },
                        attrs: { "data-test": "belowTitle" },
                      },
                      [_vm._t("belowTitle")],
                      2
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm.thumbnailDisplay !== _vm.ThumbnailDisplays.NONE
              ? _c(
                  "div",
                  { staticClass: "k-thumbnail" },
                  [
                    _c("KImg", {
                      attrs: {
                        "data-test": "thumbnail-img",
                        src: _vm.thumbnailSrc,
                        scaleType: _vm.thumbnailScaleType,
                        aspectRatio: _vm.thumbnailAspectRatio,
                        isDecorative: true,
                        appearanceOverrides: _vm.thumbnailStyles,
                      },
                      on: { error: _vm.onThumbnailError },
                    }),
                    !_vm.thumbnailSrc || _vm.thumbnailError
                      ? _c(
                          "span",
                          { staticClass: "k-thumbnail-placeholder" },
                          [_vm._t("thumbnailPlaceholder")],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm.hasFooterArea
            ? _c(
                "div",
                { staticClass: "k-footer", attrs: { "data-test": "footer" } },
                [_vm._t("footer")],
                2
              )
            : _vm._e(),
        ]
      ),
      _vm.$slots.select
        ? _c(
            "div",
            {
              staticClass: "k-selection-control",
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  $event.stopPropagation()
                },
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [_vm._t("select")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }